module.exports = __webpack_public_path__ + "img/info-blue-icon.1a7e52cd.svg";